export default __webpack_public_path__ + "static/media/ShipporiMincho-Bold.3727fe6a.ttf";